import React from 'react'
import { Card, CardContent, CardTitle, Col, Divider, Flex, Row, Typography } from '@airbus/components-react/components'
import { useTranslation } from 'react-i18next'
import { Stock } from 'types/stock'

const StockCard = ({
  firstTitle,
  firstValue,
  secondTitle,
  secondValue,
  secondColor,
  thirdTitle,
  thirdValue,
}: Record<string, string | number | null>) => (
  <Card style={{ maxWidth: 'unset', height: '110px', marginRight: '1rem', marginBottom: '2rem' }}>
    <CardContent>
      <Flex justify='space-around'>
        <div>
          <CardTitle>{firstTitle}</CardTitle>
          <Typography style={{ fontWeight: 'bold' }}>{firstValue || '-'}</Typography>
        </div>
        <Divider vertical />
        <div>
          <CardTitle>{secondTitle}</CardTitle>
          <Typography style={{ color: secondColor as 'red' | 'orange' | 'initial', fontWeight: 'bold' }}>
            {secondValue || '-'}
          </Typography>
        </div>
        {thirdTitle && (
          <>
            <Divider vertical />
            <div>
              <CardTitle>{thirdTitle}</CardTitle>
              <Typography style={{ fontWeight: 'bold' }}>{thirdValue || '-'}</Typography>
            </div>
          </>
        )}
      </Flex>
    </CardContent>
  </Card>
)

const getStatusColor = (blackList: string) => {
  if (blackList === '') return 'unset'
  else if (blackList && Number(blackList) < 700) return 'orange'
  else return 'red'
}

const StockDetail = ({ stock }: { stock: Stock }) => {
  const { t } = useTranslation()
  return (
    <div style={{ padding: '0 3rem' }}>
      <Row justify='start'>
        <Col xxs={10} lg={7}>
          <StockCard
            firstTitle={t('9500047')}
            firstValue={stock.pn}
            secondTitle={t('7000248')}
            secondValue={stock.designation}
            thirdTitle={t('7000270')}
            thirdValue={stock.codFab}
          />
        </Col>
        <Col xxs={8} lg={5}>
          <StockCard
            firstTitle={t('7000956')}
            firstValue={`${stock.codeType} - ${stock.libType}`}
            secondTitle={t('9510084')}
            secondValue={stock.statusBlacklist}
            secondColor={getStatusColor(stock.blackList)}
          />
        </Col>
      </Row>
      <Row justify='start'>
        <Col xxs={7} md={4}>
          <StockCard
            firstTitle={t('1CMG001')}
            firstValue={`${stock.store?.companyCode} / ${stock.store?.storeCode}`}
            secondTitle={t('7001180')}
            secondValue={stock.stock}
          />
        </Col>
        <Col xxs={7} md={4}>
          <StockCard
            firstTitle={t('7000973')}
            firstValue={`${stock.storeAppro?.companyCode} / ${stock.storeAppro?.storeCode}`}
            secondTitle={t('7001180')}
            secondValue={stock.stockAppro}
          />
        </Col>
        <Col xxs={7} md={4}>
          <StockCard
            firstTitle={t('1P00425')}
            firstValue={stock.numdoc}
            secondTitle={t('9500191')}
            secondValue={stock.status}
          />
        </Col>
      </Row>
    </div>
  )
}

export default StockDetail
